import React from 'react';
import PaginaNoEncontradaVista from './vista/paginaNoEncontradaVista';

const PaginaNoEncontrada: React.FunctionComponent = () => <PaginaNoEncontradaVista />;

export default PaginaNoEncontrada;
